export {default} from './TipsEmptyState';
